import type { PhoneNumber } from 'lib-shared-legacy-types';
import { createContext, FC, useContext, useEffect } from 'react';

import type { WithPhoneNumbersInjectedProps } from 'hocs';
import { withPhoneNumbers } from 'hocs';

type ContextT = {
  fetchNumbers: WithPhoneNumbersInjectedProps['phoneNumbers']['getItems'];
  showReleaseNumber: (number: PhoneNumber) => void;
  showChangeOutbound: (number: PhoneNumber) => void;
  showEditNumber: (number: PhoneNumber) => void;
  showNewFlow: (number: PhoneNumber) => void;
} & WithPhoneNumbersInjectedProps;

export const NumberTableContext = createContext<ContextT | null>(null);

export const useNumberTable = (): ContextT | never => {
  const context = useContext(NumberTableContext);

  if (!context) {
    throw new Error('Missing NumberTableProvider');
  }

  return context;
};

const NumberTableProvider: FC<ContextT> = ({ children, ...context }) => {
  const {
    phoneNumbers: { getItems },
  } = context;

  useEffect(() => void getItems(), [getItems]);

  return (
    <NumberTableContext.Provider value={context}>
      {children}
    </NumberTableContext.Provider>
  );
};

export default withPhoneNumbers(NumberTableProvider);
